import React, { useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from "react-intl"
import { useSelector } from 'react-redux'
import { useCatalogue } from "../components/context/CatalogueWrapper";
import { useFormik } from 'formik';
import * as Yup from "yup"
import { TailSpin } from 'react-loader-spinner';


//Form schema
let fieldEmpty = <FormattedMessage id="app.catalog.form.validation" defaultMessage="Field Required" />
const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/
const formSchema = Yup.object({
    phone: Yup.string().matches(phoneRegExp, "Phone is not valid").required(fieldEmpty),
    delivery_address: Yup.string().required(fieldEmpty),
    zip: Yup.string().required(fieldEmpty),
    city: Yup.string().required(fieldEmpty),
    country: Yup.string().required(fieldEmpty),
    user_comment: Yup.string(),
})

const CatalogRequestForm = ({ handleSubmit, handleChange, values }) => {


    const userProfile = useSelector(state => state.userProfile)
    const { profile } = userProfile
    const [orderSent, setOrderSent] = useState(false)

    const { selectedCatalogues, toggleCatalogueSelection } = useCatalogue();

    const formik = useFormik({
        initialValues: {
            phone: profile?.data && profile?.data?.phone,
            delivery_address: "",
            zip: "",
            city: "",
            country: "",
            user_comment: "",
            selectedCatalogues: [],
        },
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            handleSubmit(values);
            resetForm();
            if (formik.submitCount > 0) {
                setOrderSent(true)
            }
        },
        validationSchema: formSchema
    })

    useEffect(() => { setTimeout(() => setOrderSent(false), 1000) }, [])

    const colorsData = useSelector(state => state.optionsColors)
    const { loading, colors } = colorsData

    const intl = useIntl();

    const {
        phone,
        delivery_address,
        zip,
        city,
        country,
        user_comment,
    } = values;

    let labelStyle = 'text-sm text-green-900 font-bold'

    return (
        <>
            <div className="flex flex-col md:ml-8 align-center">

                <div className='font-bold text-lg text-green-900'>
                    <FormattedMessage id="app.catalog.form.title" defaultMessage="" />
                </div>
                <div className="block rounded-lg bg-white shadow-md p-4 max-w-lg">
                    {orderSent &&
                        <div className="bg-green-200 rounded border-t-4 border-green-900 rounded-b text-green-900 px-4 py-3 shadow-md mb-4" role="alert">
                            <div className="flex">
                                <div className="py-1"><svg className="fill-current h-6 w-6 text-green-900 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" /></svg></div>
                                <div>
                                    <p className="font-bold"><FormattedMessage id="app.general.orderCreated" defaultMessage="Sample request sent" /></p>
                                </div>
                            </div>
                        </div>
                    }
                    <form onSubmit={formik.handleSubmit}>
                        <div className={selectedCatalogues.length > 0 ? '' : 'mb-14'}>
                            <p className='font-bold text-md text-green-900'>
                                <FormattedMessage id="app.catalog.form.colors.selected" defaultMessage="Selected colors" />:</p>
                        </div>

                        {selectedCatalogues.length > 0 &&
                            <div>
                                <div className='flex'>
                                    {selectedCatalogues.map((cat, i) =>
                                        <div key={i} className='mt-2 mb-2'>
                                            <span
                                                className="ml-2 rounded-full text-green-900 bg-green-200 font-semibold text-sm flex align-center cursor-pointer active:bg-gray-300 transition duration-300 ease w-max">
                                                <span className="text-green-900 flex items-center px-3 py-2">
                                                    {/* {cat} */}
                                                    {!loading && colors && colors['data'].map((color, i) =>
                                                        cat === color.id && color.name
                                                    )}
                                                </span>
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                        <div className='font-bold text-md text-green-900 mb-2'>
                            <FormattedMessage id="app.catalog.form.colors.delivery.title" defaultMessage="Enter the delivery address" />:
                        </div>

                        <div className="form-group mb-2">
                            <label className={labelStyle} htmlFor="phone"><FormattedMessage id="app.catalog.form.phone" defaultMessage="Phone" />:</label>
                            <input value={formik && formik.values.phone} onChange={formik.handleChange("phone")} onBlur={formik.handleBlur("phone")} type="text" name="phone" className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" id="exampleInput7">
                            </input>
                            <div className='text-red-400 mb-2'>
                                {formik.touched.phone && formik.errors.phone}
                            </div>

                        </div>

                        <div className="form-group mb-2">
                            <label className={labelStyle} htmlFor="delivery_address"><FormattedMessage id="app.catalog.form.address" defaultMessage="Delivery Address" />:</label>
                            <input onChange={formik.handleChange("delivery_address")} onBlur={formik.handleBlur("delivery_address")} value={formik.values.delivery_address} type="text" name="delivery_address" className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" id="exampleInput7">
                            </input>
                            <div className='text-red-400 mb-2'>
                                {formik.touched.delivery_address && formik.errors.delivery_address}
                            </div>

                        </div>
                        <div className="form-group mb-2">
                            <label className={labelStyle} htmlFor="zip"><FormattedMessage id="app.catalog.form.zip" defaultMessage="Zip" />:</label>
                            <input onChange={formik.handleChange("zip")} onBlur={formik.handleBlur("zip")} value={formik.values.zip} type="text" name="zip" className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" id="exampleInput7"
                            >
                            </input>
                            <div className='text-red-400 mb-2'>
                                {formik.touched.zip && formik.errors.zip}
                            </div>
                        </div>
                        <div className="form-group mb-2">
                            <label className={labelStyle} htmlFor="city"><FormattedMessage id="app.catalog.form.city" defaultMessage="City" />:</label>
                            <input onChange={formik.handleChange("city")} onBlur={formik.handleBlur("city")} value={formik.values.city} type="text" name="city" className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" id="exampleInput7"
                            >
                            </input>
                            <div className='text-red-400 mb-2'>
                                {formik.touched.city && formik.errors.city}
                            </div>
                        </div>

                        <div className="form-group mb-2">
                            <label className={labelStyle} htmlFor="country"><FormattedMessage id="app.catalog.form.country" defaultMessage="Country" />:</label>
                            <input onChange={formik.handleChange("country")} onBlur={formik.handleBlur("country")} value={formik.values.country} type="text" name="country" className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" id="exampleInput7"
                            >
                            </input>
                            <div className='text-red-400 mb-2'>
                                {formik.touched.country && formik.errors.country}
                            </div>
                        </div>

                        <div className="form-group mb-2 ">
                            <label className={labelStyle} htmlFor="user_comment"><FormattedMessage id="app.catalog.form.user_comment" defaultMessage="Message" />:</label>
                            <textarea name="user_comment" onBlur={formik.handleBlur("user_comment")} value={formik.values.user_comment} onChange={formik.handleChange("user_comment")}
                                className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                id="exampleFormControlTextarea13"
                                rows="2"
                            ></textarea>
                        </div>
                        {formik.isSubmitting ? (
                            <button type="submit" disabled className="w-full px-6 py-2.5 bg-green-900 text-white font-medium text-xs leading-tight uppercase rounded hover:bg-green-500 hover:shadow-lg  focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-500 active:shadow-lg transition duration-150 ease-in-out flex items-center justify-center">
                                <TailSpin
                                    height="20"
                                    width="20"
                                    color="#fff"
                                    ariaLabel="tail-spin-loading"
                                    radius="2"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    visible={true}
                                />
                            </button>
                        ) : (
                            <button type="submit" className="w-full px-6 py-2.5 bg-green-900 text-white font-medium text-xs leading-tight uppercase rounded hover:bg-green-500 hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-500 active:shadow-lg disabled:opacity-30 transition duration-150 ease-in-out">
                                <FormattedMessage id="app.catalog.form.send" defaultMessage="Send" />
                            </button>
                        )}

                    </form>
                </div>
            </div >

        </>
    )
}

export default CatalogRequestForm

